import { Pipe, PipeTransform } from "@angular/core";
import { BytesPacketsFormatterService } from "../services/util/bytes-packets-formatter.service";

/**
 * Pipe para formatar pacotes em k, M, G, T, or P.
 */
@Pipe({
    name: "packetsFormatter"
})
export class PacketsFormatterPipe implements PipeTransform {

    constructor(private readonly bytesPacketsFormatterService: BytesPacketsFormatterService) {
    }

    transform(packets: number): string {
        const ppsUnits = ["pps", "kpps", "Mpps", "Gpps", "Tpps", "Ppps"];
        return this.bytesPacketsFormatterService.format(packets, ppsUnits);
    }

}
